<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-6">
          <label class="akkurate-dark" for="name">Name <star></star></label>
          <b-form-group id="name" label-for="name" class="akkurate-dark">
            <b-form-input v-model="form.name" id="name" class="mb-3 mt-2 field-container fields" type="text"
              placeholder="Enter Name" required>
            </b-form-input>
          </b-form-group>
        </div>
        <div class="col-12 col-md-6">
          <label class="akkurate-dark" for="base_type">Base Type <star></star></label>
          <b-form-group id="base_type" label-for="base_type">
            <multiselect v-if="add_or_edit == 'edit'" disabled class="mt-2 field-container" v-model="form.base_type"
              :options="base_type_options"></multiselect>
            <multiselect v-else class="mt-2 field-container" v-model="form.base_type" :options="base_type_options">
            </multiselect>
            <errors v-if="errors.base_type">
              {{ errors.base_type[0] }}
            </errors>
          </b-form-group>
        </div>
        <div class="col-12 col-md-6">
          <b-form-group>
            <template #label>
              <label class="akkurate-dark" for="withdrawal_allowed">Withdrawal Allowed <star></star></label>
            </template>
            <b-form-radio v-model="form.withdrawal_allowed" name="withdrawal_allowed" value="1">Yes</b-form-radio>
            <b-form-radio v-model="form.withdrawal_allowed" name="withdrawal_allowed" value="0">No</b-form-radio>
            <errors v-if="errors.withdrawal_allowed">
              {{ errors.withdrawal_allowed[0] }}
            </errors>
          </b-form-group>
        </div>
        <div class="col-12 col-md-6">
          <b-form-group>
            <template #label>
              <label class="akkurate-dark" for="deposit_allowed">Deposit Allowed <star></star></label>
            </template>
            <b-form-radio v-model="form.deposit_allowed" name="deposit_allowed" value="1">Yes</b-form-radio>
            <b-form-radio v-model="form.deposit_allowed" name="deposit_allowed" value="0">No</b-form-radio>
            <errors v-if="errors.deposit_allowed">
              {{ errors.deposit_allowed[0] }}
            </errors>
          </b-form-group>
        </div>
        <div class="col-12 col-md-6">
          <label class="akkurate-dark mt-2" for="minimum_balance">Minimum Balance <star></star></label>
          <b-form-group id="minimum_balance" label-for="minimum_balance" class="akkurate-dark">
            <b-form-input v-model="form.minimum_balance" id="minimum_balance" class="mb-3 mt-2 field-container fields"
              type="number" placeholder="Enter Minimum Balance" required>
            </b-form-input>
            <errors v-if="errors.minimum_balance">
              {{ errors.minimum_balance[0] }}
            </errors>
          </b-form-group>
        </div>
        <div class="col-12 col-md-6">
          <b-form-group>
            <template #label>
              <label class="akkurate-dark mt-2" for="send_sms">Send Sms <star></star></label>
            </template>
            <b-form-radio v-model="form.send_sms" name="send_sms" value="1">Yes</b-form-radio>
            <b-form-radio v-model="form.send_sms" name="send_sms" value="0">No</b-form-radio>
            <errors v-if="errors.send_sms">
              {{ errors.send_sms[0] }}
            </errors>
          </b-form-group>
        </div>
        <div class="col-12 col-md-6">
          <label class="akkurate-dark mt-2" for="daily_deposit_amount_limit">Daily Deposit Amount Limit (GHS)<star>
            </star>
          </label>
          <b-form-group id="daily_deposit_amount_limit" label-for="daily_deposit_amount_limit" class="akkurate-dark">
            <b-form-input v-model="form.daily_deposit_amount_limit" id="daily_deposit_amount_limit"
              class="mb-3 mt-2 field-container fields" type="number" placeholder="Enter Deposit Amount Limit" required>
            </b-form-input>
            <errors v-if="errors.daily_deposit_amount_limit">
              {{ errors.daily_deposit_amount_limit[0] }}
            </errors>
          </b-form-group>
        </div>
        <div class="col-12 col-md-6">
          <label class="akkurate-dark mt-2" for="daily_deposit_frequency_limit">Daily Deposit Frequency Limit <star>
            </star>
          </label>
          <b-form-group id="daily_deposit_frequency_limit" label-for="daily_deposit_frequency_limit"
            class="akkurate-dark">
            <b-form-input v-model="form.daily_deposit_frequency_limit" id="daily_deposit_frequency_limit"
              class="mb-3 mt-2 field-container fields" type="number" placeholder="Enter Daily Deposit Frequency Limit"
              required>
            </b-form-input>
            <errors v-if="errors.daily_deposit_frequency_limit">
              {{ errors.daily_deposit_frequency_limit[0] }}
            </errors>
          </b-form-group>
        </div>

        <div class="col-12 col-md-6">
          <label class="akkurate-dark mt-2" for="daily_withdrawal_amount_limit">Daily Withdrawal Amount Limit (GHS)
            <star></star>
          </label>
          <b-form-group id="daily_withdrawal_amount_limit" label-for="daily_withdrawal_amount_limit"
            class="akkurate-dark">
            <b-form-input v-model="form.daily_withdrawal_amount_limit" id="daily_deposit"
              class="mb-3 mt-2 field-container fields" type="number" placeholder="Enter Withdrawal Amount Limit"
              required>
            </b-form-input>
            <errors v-if="errors.daily_withdrawal_amount_limit">
              {{ errors.daily_withdrawal_amount_limit[0] }}
            </errors>
          </b-form-group>
        </div>

        <div class="col-12 col-md-6">
          <label class="akkurate-dark mt-2" for="daily_withdrawal_frequency_limit">Daily Withdrawal Frequency Limit
            <star>
            </star>
          </label>
          <b-form-group id="daily_withdrawal_frequency_limit" label-for="daily_withdrawal_frequency_limit"
            class="akkurate-dark">
            <b-form-input v-model="form.daily_withdrawal_frequency_limit" id="daily_withdrawal_frequency_limit"
              class="mb-3 mt-2 field-container fields" type="number"
              placeholder="Enter Daily Withdrawal Frequency Limit" required>
            </b-form-input>
            <errors v-if="errors.daily_withdrawal_frequency_limit">
              {{ errors.daily_withdrawal_frequency_limit[0] }}
            </errors>
          </b-form-group>
        </div>

        <div class="col-12 col-md-6">
          <label class="akkurate-dark mt-2" for="unapproved_withdrawal_max_amount">Withdraw max threshold </label>
          <b-form-group id="unapproved_withdrawal_max_amount" label-for="unapproved_withdrawal_max_amount"
            class="akkurate-dark">
            <b-form-input v-model="form.unapproved_withdrawal_max_amount" id="unapproved_withdrawal_max_amount"
              class="mb-3 mt-2 field-container fields" type="number" placeholder="Enter Withdraw max threshold"
              max="5000">
            </b-form-input>
            <errors v-if="errors.unapproved_withdrawal_max_amount">
              {{ errors.unapproved_withdrawal_max_amount[0] }}
            </errors>
          </b-form-group>
        </div>

        <div class="col-12 col-md-6">
          <label class="akkurate-dark mt-2" for="coa_head">COA Head <star></star></label>
          <b-form-group id="coa_head" label-for="coa_head" class="akkurate-dark">
            <multiselect :disabled="add_or_edit == 'edit'" class="mt-2 field-container" v-model="form.coa_head"
              :options="coa_heads_options" label="display_name">
            </multiselect>
            <errors v-if="errors.coa_head">
              {{ errors.coa_head[0] }}
            </errors>
          </b-form-group>
        </div>

        <div class="col-12 col-md-6">
          <b-form-group>
            <template #label>
              <label class="akkurate-dark" for="apply_withdrawal_charges">Apply Withdrawal Charges<star></star>
              </label>
            </template>
            <b-form-radio v-model="form.apply_withdrawal_charges" name="apply_withdrawal_charges"
              value="1">Yes</b-form-radio>
            <b-form-radio v-model="form.apply_withdrawal_charges" name="apply_withdrawal_charges"
              value="0">No</b-form-radio>
            <errors v-if="errors.apply_withdrawal_charges">
              {{ errors.apply_withdrawal_charges[0] }}
            </errors>
          </b-form-group>
        </div>

        <template v-if="chargesApply">
          <div class="col-12 col-md-6">
            <b-form-group>
              <template #label>
                <label class="akkurate-dark">Charge type <star></star></label>
              </template>
              <b-form-radio v-model="form.withdrawal_charge_mode" name="withdrawal_charge_mode"
                value="flat">Flat amount (GHS)</b-form-radio>
              <b-form-radio v-model="form.withdrawal_charge_mode" name="withdrawal_charge_mode"
                value="percentage_rate">Percentage of withdrawal amount</b-form-radio>
            </b-form-group>
            <errors v-if="errors.withdrawal_charge_mode">{{ errors.withdrawal_charge_mode[0] }}</errors>
          </div>

          <div class="col-12 col-md-6">
            <b-form-group label-for="withdrawal_charges_amount" class="mb-3">
              <template #label>
                <label class="akkurate-dark" for="withdrawal_charges_amount">{{ withdrawalAmountLabel }}
                  <star></star></label>
              </template>
              <b-form-input id="withdrawal_charges_amount" v-model="form.withdrawal_charges_amount"
                name="withdrawal_charges_amount" class="mt-2 field-container fields" type="number"
                step="any" min="0" :max="form.withdrawal_charge_mode === 'percentage_rate' ? 100 : undefined">
              </b-form-input>
              <errors v-if="errors.withdrawal_charges_amount">
                {{ errors.withdrawal_charges_amount[0] }}
              </errors>
            </b-form-group>
          </div>

          <div class="col-12 col-md-6">
            <b-form-group>
              <template #label>
                <label class="akkurate-dark">Charge applies <star></star></label>
              </template>
              <b-form-radio v-model="form.withdrawal_charge_frequency" name="withdrawal_charge_frequency"
                value="every_transaction">Every withdrawal</b-form-radio>
              <b-form-radio v-model="form.withdrawal_charge_frequency" name="withdrawal_charge_frequency"
                value="after_quota">After free withdrawals in a period</b-form-radio>
            </b-form-group>
            <errors v-if="errors.withdrawal_charge_frequency">{{ errors.withdrawal_charge_frequency[0] }}</errors>
          </div>

          <template v-if="form.withdrawal_charge_frequency === 'after_quota'">
            <div class="col-12 col-md-6">
              <label class="akkurate-dark" for="withdrawal_charge_quota_period">Free-withdrawal period <star></star>
              </label>
              <b-form-group id="withdrawal_charge_quota_period" label-for="withdrawal_charge_quota_period"
                class="akkurate-dark">
                <b-form-select id="withdrawal_charge_quota_period" class="mt-2 field-container"
                  v-model="form.withdrawal_charge_quota_period" :options="quotaPeriodOptions" />
              </b-form-group>
              <errors v-if="errors.withdrawal_charge_quota_period">
                {{ errors.withdrawal_charge_quota_period[0] }}
              </errors>
            </div>
            <div class="col-12 col-md-6">
              <label class="akkurate-dark" for="withdrawal_charge_quota_free_withdrawals">Free withdrawals per period
                <star></star></label>
              <b-form-group id="withdrawal_charge_quota_free_withdrawals"
                label-for="withdrawal_charge_quota_free_withdrawals" class="akkurate-dark">
                <b-form-input id="withdrawal_charge_quota_free_withdrawals"
                  v-model="form.withdrawal_charge_quota_free_withdrawals"
                  class="mt-2 field-container fields" type="number" min="0" step="1"
                  placeholder="e.g. 3 (fee from 4th withdrawal in period)">
                </b-form-input>
                <small class="text-muted d-block mt-1">Non-negative integer; 0 = no free withdrawals in the period.
                </small>
              </b-form-group>
              <errors v-if="errors.withdrawal_charge_quota_free_withdrawals">
                {{ errors.withdrawal_charge_quota_free_withdrawals[0] }}
              </errors>
            </div>
          </template>

          <div class="col-12 col-md-6">
            <label class="akkurate-dark mt-2" for="charges_coa">Charges COA <star></star></label>
            <b-form-group id="charges_coa" label-for="charges_coa" class="akkurate-dark">
              <multiselect class="mt-2 field-container" v-model="form.charges_coa"
                :options="coa_subheads_options" label="name" :custom-label="coaSubheadLabel">
              </multiselect>
              <errors v-if="errors.charges_coa">
                {{ errors.charges_coa[0] }}
              </errors>
            </b-form-group>
          </div>
        </template>

      </div>


    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import ApiService from "@/core/services/api.service";
export default {
  components: { Multiselect },
  props: ["form", "errors", "add_or_edit"],
  mounted() {
    this.getCOAHead();
    this.ensureWithdrawalChargeDefaults();
  },
  data() {
    return {
      base_type_options: ['Savings', 'Shares', 'Current', 'Group', 'Corporate', 'Fixed_Deposits'],
      coa_heads_options: [],
      coa_subheads_options: [],
    }
  },
  computed: {
    chargesApply() {
      const v = this.form && this.form.apply_withdrawal_charges;
      return v === "1" || v === 1 || v === true || v === "true";
    },
    withdrawalAmountLabel() {
      if (this.form && this.form.withdrawal_charge_mode === "percentage_rate") {
        return "Charge percentage (%)";
      }
      return "Charge amount (GHS)";
    },
    quotaPeriodOptions() {
      return [
        { value: "", text: "Select period…" },
        { value: "day", text: "Day" },
        { value: "week", text: "Week" },
        { value: "month", text: "Month" },
        { value: "year", text: "Year" },
      ];
    },
  },
  watch: {
    "form.apply_withdrawal_charges"(v) {
      if (v === "0" || v === 0 || v === false) {
        this.clearWithdrawalChargeFields();
      }
    },
    "form.withdrawal_charge_frequency"(v) {
      if (v === "every_transaction") {
        this.$set(this.form, "withdrawal_charge_quota_period", "");
        this.$set(this.form, "withdrawal_charge_quota_free_withdrawals", "");
      }
    },
  },
  methods: {
    ensureWithdrawalChargeDefaults() {
      if (!this.form || typeof this.form !== "object") {
        return;
      }
      if (this.form.withdrawal_charge_mode == null || this.form.withdrawal_charge_mode === "") {
        this.$set(this.form, "withdrawal_charge_mode", "flat");
      }
      if (
        this.form.withdrawal_charge_frequency == null ||
        this.form.withdrawal_charge_frequency === ""
      ) {
        this.$set(this.form, "withdrawal_charge_frequency", "every_transaction");
      }
    },
    clearWithdrawalChargeFields() {
      this.$set(this.form, "withdrawal_charges_amount", "");
      this.$set(this.form, "charges_coa", null);
      this.$set(this.form, "withdrawal_charge_mode", "flat");
      this.$set(this.form, "withdrawal_charge_frequency", "every_transaction");
      this.$set(this.form, "withdrawal_charge_quota_period", "");
      this.$set(this.form, "withdrawal_charge_quota_free_withdrawals", "");
    },
    async getCOAHead() {
      this.$Progress.start();
      await ApiService.post('/accounts/account-types/dropdown')
        .then((response) => {
          this.$Progress.finish();
          // console.log(response.data.data)
          this.coa_heads_options = response.data.coa_heads.map(index => {
            return {
              'id': index.id,
              'display_name': index.display_name
            }
          });
          this.coa_subheads_options = response.data.coa_subheads.map(index => {
            return {
              'id': index.id,
              'name': index.name,
              'code': index.code,
              'coabranch': index.coabranch,
            }
          });
        }).catch((error) => {
          this.$Progress.fail();
          // console.log(error)
        })
    },
     coaSubheadLabel ({name, code, coabranch}) {
      return `${code} — ${name} (${coabranch?.name})`;
    }
  }


}
</script>